import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import { useCurrencyContext } from '~/contexts/Currencies';
import JourneyDataContext from '~/contexts/JourneyDataContext';
import useJourneyData from '~/hooks/useJourneyData';
import { useCurrentJourneyTotal } from '~/stores/journeyStore';
import { formatGBP } from '~/utils/currencyHelpers';
import { getPreDiscountPrice, hasLoyaltyPricing } from '~/utils/loyaltyPricing';
import { pricePerPerson } from '~/utils/paxHelpers';
export const useLoyaltyPricing = () => {
  const $ = _c(41);
  const {
    loyaltyDiscount: t0,
    loyaltyTierId,
    loyaltyTierName
  } = useContext(JourneyDataContext);
  const loyaltyDiscount = t0 === undefined ? 0 : t0;
  const {
    details: t1,
    user,
    journeyType
  } = useJourneyData();
  const {
    totalPrice
  } = t1;
  const updatedTotal = useCurrentJourneyTotal();
  const {
    convertPriceInGBP
  } = useCurrencyContext();
  const isTemplate = journeyType === "asTemplate";
  const adults = isTemplate ? user.numberOfAdults : user.adult_count;
  const discountedTotal = updatedTotal || totalPrice;
  let t10;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== adults || $[1] !== convertPriceInGBP || $[2] !== discountedTotal || $[3] !== loyaltyDiscount || $[4] !== loyaltyTierId || $[5] !== loyaltyTierName || $[6] !== user.childAges) {
    const discountedPerPerson = pricePerPerson(discountedTotal, adults, user.childAges);
    let t11;
    if ($[16] !== loyaltyDiscount || $[17] !== loyaltyTierName) {
      t11 = hasLoyaltyPricing(loyaltyDiscount, loyaltyTierName);
      $[16] = loyaltyDiscount;
      $[17] = loyaltyTierName;
      $[18] = t11;
    } else {
      t11 = $[18];
    }
    const hasDiscount = t11;
    let t12;
    if ($[19] !== convertPriceInGBP) {
      t12 = amount => convertPriceInGBP(amount) || formatGBP(amount);
      $[19] = convertPriceInGBP;
      $[20] = t12;
    } else {
      t12 = $[20];
    }
    const formatPrice = t12;
    let t13;
    if ($[21] !== discountedTotal || $[22] !== hasDiscount || $[23] !== loyaltyDiscount) {
      t13 = hasDiscount ? getPreDiscountPrice(discountedTotal, loyaltyDiscount) : discountedTotal;
      $[21] = discountedTotal;
      $[22] = hasDiscount;
      $[23] = loyaltyDiscount;
      $[24] = t13;
    } else {
      t13 = $[24];
    }
    const originalTotal = t13;
    const originalPerPerson = hasDiscount ? getPreDiscountPrice(discountedPerPerson, loyaltyDiscount) : discountedPerPerson;
    t2 = hasDiscount;
    t3 = loyaltyDiscount;
    t4 = loyaltyTierId;
    t5 = loyaltyTierName;
    t6 = discountedTotal;
    if ($[25] !== discountedTotal || $[26] !== formatPrice) {
      t7 = formatPrice(discountedTotal);
      $[25] = discountedTotal;
      $[26] = formatPrice;
      $[27] = t7;
    } else {
      t7 = $[27];
    }
    if ($[28] !== formatPrice || $[29] !== originalTotal) {
      t8 = formatPrice(originalTotal);
      $[28] = formatPrice;
      $[29] = originalTotal;
      $[30] = t8;
    } else {
      t8 = $[30];
    }
    t9 = formatPrice(discountedPerPerson);
    t10 = formatPrice(originalPerPerson);
    $[0] = adults;
    $[1] = convertPriceInGBP;
    $[2] = discountedTotal;
    $[3] = loyaltyDiscount;
    $[4] = loyaltyTierId;
    $[5] = loyaltyTierName;
    $[6] = user.childAges;
    $[7] = t10;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t10 = $[7];
    t2 = $[8];
    t3 = $[9];
    t4 = $[10];
    t5 = $[11];
    t6 = $[12];
    t7 = $[13];
    t8 = $[14];
    t9 = $[15];
  }
  let t11;
  if ($[31] !== t10 || $[32] !== t2 || $[33] !== t3 || $[34] !== t4 || $[35] !== t5 || $[36] !== t6 || $[37] !== t7 || $[38] !== t8 || $[39] !== t9) {
    t11 = {
      hasLoyaltyDiscount: t2,
      loyaltyDiscount: t3,
      loyaltyTierId: t4,
      loyaltyTierName: t5,
      discountedTotal: t6,
      discountedTotalFormatted: t7,
      originalTotalFormatted: t8,
      discountedPerPersonFormatted: t9,
      originalPerPersonFormatted: t10
    };
    $[31] = t10;
    $[32] = t2;
    $[33] = t3;
    $[34] = t4;
    $[35] = t5;
    $[36] = t6;
    $[37] = t7;
    $[38] = t8;
    $[39] = t9;
    $[40] = t11;
  } else {
    t11 = $[40];
  }
  return t11;
};